import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconDiscussion: React.FC<IconProps> = ({ width = 26, height = 26 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 26 26"
            fill="none"
        >
            <g clip-path="url(#clip0_5357_14195)">
                <path
                    d="M8.5759 8.8304C8.86194 9.11643 9.32566 9.11643 9.61169 8.8304L13.5179 4.92415C13.804 4.63811 13.804 4.17439 13.5179 3.88835C13.2319 3.60232 12.7682 3.60232 12.4822 3.88835L9.09377 7.27673L7.65852 5.84148C7.37249 5.55544 6.90876 5.55544 6.62273 5.84148C6.33669 6.12751 6.33669 6.59124 6.62273 6.87727L8.5759 8.8304Z"
                    fill="black"
                />
                <path
                    d="M23.3027 10.2656H19.6406V2.69727C19.6406 1.48374 18.6569 0.5 17.4434 0.5H2.69727C1.48374 0.5 0.5 1.48374 0.5 2.69727V11.4863C0.5 12.6999 1.48374 13.6836 2.69727 13.6836H2.94141V15.9785C2.94141 16.6099 3.68682 16.9454 4.15947 16.5268L6.35938 14.5783V20.2754C6.35938 21.4889 7.34312 22.4727 8.55664 22.4727H18.6321L21.8405 25.3144C22.3131 25.733 23.0586 25.3975 23.0586 24.7661V22.4727H23.3027C24.5163 22.4727 25.5 21.4889 25.5 20.2754V12.4629C25.5 11.2494 24.5163 10.2656 23.3027 10.2656ZM4.40625 14.3514V12.9512C4.40625 12.5467 4.07832 12.2188 3.67383 12.2188H2.69727C2.29277 12.2188 1.96484 11.8908 1.96484 11.4863V2.69727C1.96484 2.29277 2.29277 1.96484 2.69727 1.96484H17.4434C17.8479 1.96484 18.1758 2.29277 18.1758 2.69727V10.2656H8.55664C7.34312 10.2656 6.35938 11.2494 6.35938 12.4629V12.6215L4.40625 14.3514ZM24.0352 20.2754C24.0352 20.6799 23.7072 21.0078 23.3027 21.0078H22.3262C21.9217 21.0078 21.5938 21.3357 21.5938 21.7402V23.1405L19.3938 21.1919C19.2599 21.0733 19.0871 21.0078 18.9082 21.0078H8.55664C8.15215 21.0078 7.82422 20.6799 7.82422 20.2754V12.4629C7.82422 12.0584 8.15215 11.7305 8.55664 11.7305H23.3027C23.7072 11.7305 24.0352 12.0584 24.0352 12.4629V20.2754Z"
                    fill="black"
                />
                <path
                    d="M18.4007 13.8982C18.1147 13.6121 17.651 13.6121 17.3649 13.8982L15.9297 15.3334L14.4945 13.8981C14.2084 13.6121 13.7447 13.6121 13.4587 13.8981C13.1726 14.1842 13.1726 14.6479 13.4587 14.9339L14.8939 16.3692L13.4587 17.8044C13.1726 18.0904 13.1726 18.5541 13.4587 18.8402C13.7447 19.1262 14.2084 19.1262 14.4945 18.8402L15.9297 17.405L17.365 18.8402C17.651 19.1262 18.1147 19.1262 18.4008 18.8402C18.6868 18.5541 18.6868 18.0904 18.4008 17.8044L16.9655 16.3692L18.4008 14.9339C18.6867 14.6479 18.6867 14.1842 18.4007 13.8982Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_5357_14195">
                    <rect width="25" height="25" fill="white" transform="translate(0.5 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconDiscussion;
